import { PhoneNumberFormat, PhoneNumberUtil } from 'google-libphonenumber';

/**
 * Formats a phone number based on the country code
 * @param phoneNumber
 * @param countryCode
 */
export function formatPhoneNumber(phoneNumber: string, countryCode: string) {
  const phoneUtil = PhoneNumberUtil.getInstance();
  const number = phoneUtil.parseAndKeepRawInput(phoneNumber, countryCode.toUpperCase());
  return phoneUtil.format(number, PhoneNumberFormat.NATIONAL);
}
